import React from 'react';
import { Card } from '../../components/Card/Card';
import css from './review.module.css';
import { AvatarSmall } from '../../components';

const ReviewCard = ({ user, stars = 0, content }) => {
  const starsArray = Array.from({ length: 5 }, (_, index) => index < stars);
  const starElements = starsArray.map((isFull, index) => <Star key={index} isFull={isFull} />);
  return (
    <Card>
      <div className={css.card}>
        <div className={css.cardStars}>
          {starElements}
          <div className={css.starsTextNumber}>{stars}</div>
          <div className={css.starsTextRest}>/5</div>
        </div>
        <div className={css.cardContentWrapper}>
          <div className={css.cardContentText}>{content}</div>
          <div className={css.cardContentAuthor}>
            <AvatarSmall user={user} />
            {user?.attributes?.profile?.displayName}
          </div>
        </div>
      </div>
    </Card>
  );
};

export const Star = ({ isFull, size = 18 }) => {
  return isFull ? (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6409 10.8693C13.4609 11.0643 13.3709 11.3343 13.4084 11.6043L13.9484 15.4968C14.0459 16.1943 13.3484 16.7193 12.7484 16.4043L9.37339 14.6718C9.13339 14.5518 8.86339 14.5518 8.63089 14.6718L5.25589 16.4043C4.64839 16.7193 3.95839 16.1943 4.05589 15.4968L4.58839 11.6043C4.62589 11.3343 4.54339 11.0643 4.36339 10.8693L1.73839 8.04184C1.26589 7.53934 1.53589 6.69184 2.19589 6.57184L5.90089 5.89684C6.16339 5.85184 6.38089 5.68684 6.50089 5.44684L8.25589 1.96684C8.57089 1.34434 9.42589 1.34434 9.74089 1.96684L11.4959 5.44684C11.6159 5.68684 11.8409 5.85184 12.0959 5.89684L15.8009 6.57184C16.4684 6.69184 16.7309 7.53934 16.2659 8.04184L13.6409 10.8693Z"
        stroke="#FECC02"
        stroke-miterlimit="10"
      />
      <path
        d="M13.6409 10.8693C13.4609 11.0643 13.3709 11.3343 13.4084 11.6043L13.9484 15.4968C14.0459 16.1943 13.3484 16.7193 12.7484 16.4043L9.37339 14.6718C9.13339 14.5518 8.86339 14.5518 8.63089 14.6718L5.25589 16.4043C4.64839 16.7193 3.95839 16.1943 4.05589 15.4968L4.58839 11.6043C4.62589 11.3343 4.54339 11.0643 4.36339 10.8693L1.73839 8.04184C1.26589 7.53934 1.53589 6.69184 2.19589 6.57184L5.90089 5.89684C6.16339 5.85184 6.38089 5.68684 6.50089 5.44684L8.25589 1.96684C8.57089 1.34434 9.42589 1.34434 9.74089 1.96684L11.4959 5.44684C11.6159 5.68684 11.8409 5.85184 12.0959 5.89684L15.8009 6.57184C16.4684 6.69184 16.7309 7.53934 16.2659 8.04184L13.6409 10.8693Z"
        fill="#FECC02"
      />
    </svg>
  ) : (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.26066 1.96684C8.57553 1.34434 9.43019 1.34434 9.74506 1.96684L11.4994 5.44684C11.6193 5.68684 11.8442 5.85184 12.0991 5.90434L15.8026 6.57184C16.4698 6.69184 16.7322 7.53934 16.2599 8.04934L13.636 10.8693C13.4561 11.0643 13.3736 11.3343 13.4111 11.6043L13.9434 15.4968C14.0408 16.1943 13.3511 16.7193 12.7439 16.4043L9.37021 14.6718C9.13781 14.5518 8.86042 14.5518 8.62801 14.6718L5.25437 16.4043C4.64712 16.7118 3.9574 16.1943 4.05486 15.4968L4.58714 11.6043C4.62463 11.3343 4.54216 11.0643 4.36223 10.8693L1.73829 8.04934C1.26598 7.54684 1.53588 6.69184 2.19561 6.57184L5.89911 5.90434C6.15401 5.85934 6.37892 5.68684 6.49887 5.44684L8.25316 1.96684H8.26066Z"
        stroke="#D3D3D3"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export default ReviewCard;
